import { client } from 'configs/sanity';

const works = async () => {
  try {
    const response = await client.fetch(`*[_type == "work"] | order(orderRank) {
      "tags": tags[]->tag,
      "slug": slug.current, 
      "title": preview.title, 
      "description": preview.description, 
      "media": coalesce(
        preview.media.asset->url,
        preview.media.file.asset->url
      ),
      "mediaHover": coalesce(
        preview.hover.asset->url,
        preview.hover.file.asset->url
      )
    }`);
    return response;
  } catch (error) {
    console.error('Error fetching works:', error);
    return [];
  }
}

const work = async (params) => {
  try {
    const projects = await client.fetch(`*[_type == "work"] | order(orderRank) {
      "slug": slug.current,
      title,
      client,
      "tags": tags[]->tag,
      "media": coalesce(
        preview.media.asset->url,
        preview.media.file.asset->url
      ),
      "mediaHover": coalesce(
        preview.hover.asset->url,
        preview.hover.file.asset->url
      ),
      "heroBackground": heroBackground.asset->url,
      "hero": { "image": heroBackground.asset->url },
      seo {
        title,
        description,
        "image": image.asset->url
      },
      new {
        link,
        source,
        title,
        "backgroundColor": backgroundColor.hex
      },
      overview {
        title,
        description,
        project,
        services,
        "media": {
          "fullWidthMedia": {
            "source": media.file.asset->url,
            "controls": media.controls        
          }
        }
      },
      approach {
        title,
        description,
        "media": {
          "fullWidthMedia": {
            "source": media.file.asset->url,
            "controls": media.controls        
          },
          "leftColumnMedia": {
            "source": mediaColumnLeft.file.asset->url,
            "controls": mediaColumnLeft.controls
          },
          "rightColumnMedia": {
            "source": mediaColumnRight.file.asset->url,
            "controls": mediaColumnRight.controls
          }
        }
      },
      challenge {
        title,
        description,
        "media": {
          "fullWidthMedia": {
            "source": media.file.asset->url,
            "controls": media.controls        
          },
          "leftColumnMedia": {
            "source": mediaColumnLeft.file.asset->url,
            "controls": mediaColumnLeft.controls
          },
          "rightColumnMedia": {
            "source": mediaColumnRight.file.asset->url,
            "controls": mediaColumnRight.controls
          }
        }
      },
      feature {
        title,
        description,
        "media": {
          "fullWidthMedia": {
            "source": media.file.asset->url,
            "controls": media.controls        
          }
        }
      },
      recognitions[] {
        title,
        description,
        link,
        "logo": logo.asset->url
      }
    }`);
    const current = projects.find(p => p.slug === params.slug);
    return { work: current ?? null, projects };
  } catch (error) {
    console.error('Error fetching work:', error);
    return { work: null, projects: [] };
  }
}

const home = async () => {
  try {
    const response = await client.fetch(`*[_id == "home"]{
      works[]->{
        "tags": tags[]->tag,
        "slug": slug.current,
        preview {
          description,
          title,
          "media": coalesce(media.asset->url, media.file.asset->url),
          "mediaHover": coalesce(hover.asset->url, hover.file.asset->url)
        }
      }
    }`);
    return response; 
  } catch (error) {
    console.error('Error fetching works (home):', error);
    return [];
  }
}

export { works, work, home };